
export default function Location() {
  const locations = [
    {
      name: '부산',
      address: '부산광역시 북구 양달로 74 상가동 104호',
      detail: '화명동, 화명동부종합상가',
      phone: '051-915-5841',
    },
    {
      name: '대구',
      address: '대구광역시 달성군 다사읍 서재로 120 상가동 210호',
      detail: '서재화진금봉타운',
      phone: '053-592-3122',
    },
    {
      name: '울산',
      address: '울산광역시 남구 대학로 84-1, 2층 208-2호',
      detail: '무거동',
      phone: '052-260-5841',
    },
  ];

  return (
    <section id="location" className="py-32 lg:py-40 bg-warmWhite">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">

        {/* Section Title */}
        <div className="mb-20 lg:mb-28">
          <p className="text-xs font-medium tracking-widest uppercase text-primary mb-4">Location</p>
          <h2 className="text-3xl lg:text-5xl font-light text-black leading-tight tracking-tight">
            오시는 길
          </h2>
        </div>

        {/* Locations */}
        <div className="grid lg:grid-cols-3 gap-px bg-lineGray">
          {locations.map((location, index) => (
            <div
              key={index}
              className="bg-warmWhite px-10 py-12 hover:bg-white transition-colors duration-300 flex flex-col"
            >
              {/* 지점명 */}
              <h3 className="text-3xl lg:text-4xl font-light text-black mb-10 pb-8 border-b border-lineGray">
                {location.name}
              </h3>

              {/* 정보 목록 */}
              <div className="flex flex-col gap-8 flex-1">

                {/* 주소 */}
                <div className="flex flex-col gap-2">
                  <p className="text-xs font-medium tracking-widest uppercase text-textGray">주소</p>
                  <p className="text-sm text-black font-light leading-relaxed">
                    {location.address}
                  </p>
                  <p className="text-xs text-textGray font-light">
                    ({location.detail})
                  </p>
                </div>

                {/* 전화 */}
                <div className="flex flex-col gap-2">
                  <p className="text-xs font-medium tracking-widest uppercase text-textGray">전화</p>
                  <a
                    href={`tel:${location.phone.replace(/-/g, '')}`}
                    className="text-sm text-black font-light hover:text-primary transition-colors cursor-pointer"
                  >
                    {location.phone}
                  </a>
                </div>

                {/* 운영 */}
                <div className="flex flex-col gap-2">
                  <p className="text-xs font-medium tracking-widest uppercase text-textGray">운영</p>
                  <p className="text-sm text-black font-light">평일 10:00 - 18:00</p>
                </div>

              </div>

              {/* 하단 버튼 */}
              <div className="mt-10 pt-8 border-t border-lineGray">
                <a
                  href={`tel:${location.phone.replace(/-/g, '')}`}
                  className="inline-flex items-center gap-2 text-sm font-light text-black hover:text-primary transition-colors cursor-pointer"
                >
                  <i className="ri-phone-line"></i>
                  <span>전화 문의</span>
                </a>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
